import React, { createContext, useState } from "react";

export const LeaderboardDataContext = createContext();

export const LeaderboardDataProvider = ({ children }) => {
  const [reportDetails, setReportDetails] = useState({
    reports: [],
    filter: [],
    allAssignees: [],
  });
  const [leaderboardTotals, setLeaderboardTotals] = useState({})
  const [reportAssignees, setReportAssignees] = useState([]);

  const [departmentFlaggedHrRanks, setDepartmentFlaggedHrRanks] = useState([]);
  const [assigneeFlaggedHrRanks, setAssigneeFlaggedHrRanks] = useState([]);
  const [departmentEfficiencyRanks, setDepartmentEfficiencyRanks] = useState(
    []
  );
  const [assigneeEfficiencyRanks, setAssigneeEfficiencyRanks] = useState([]);

  const updateReportDetails = (details) => {
    let detailNames = [];
    let reports = [];
    const initialValue = 0

    details?.forEach((entry) => {
      detailNames.push(entry.jobAssignee);
      reports.push({
        name: entry.jobAssignee,
        totalFlagged: entry.laborFlags.reduce(
          (sum, flag) => sum + flag.flaggedHours,
          initialValue
        ),
        toPrint: false,
        entries: [...entry.laborFlags],
      });
    });

    let allAssignees = [];
    reports.forEach((entry) => {
      if (entry.totalFlagged !== 0 && entry.name !== "No Assignee") {
        allAssignees.push(entry.name);
      }
    });

    setReportDetails((prevState) => ({
      ...prevState,
      reports,
      filter: [],
      allAssignees,
    }));
  };

  const updateLeaderboardTotals = (totals) => {
    updateDepartmentEfficiencyRanks(totals.departmentEfficiency)
    updateDepartmentFlaggedHrRanks(totals.departmentRank)
    updateAssigneeEfficiencyRanks(totals.assigneeEfficiency)
    updateAssigneeFlaggedHrRanks(totals.assigneeRank)
    setLeaderboardTotals(totals)
  }

  const updateDepartmentFlaggedHrRanks = (ranks) => {
    setDepartmentFlaggedHrRanks((prevState) => [...ranks]);
  };
  const updateAssigneeFlaggedHrRanks = (ranks) => {
    setAssigneeFlaggedHrRanks((prevState) => [...ranks]);
  };
  const updateDepartmentEfficiencyRanks = (ranks) => {
    setDepartmentEfficiencyRanks((prevState) => [...ranks]);
  };
  const updateAssigneeEfficiencyRanks = (ranks) => {
    setAssigneeEfficiencyRanks((prevState) => [...ranks]);
  };
  const updateReportAssignees = (assignees) => {
    setReportAssignees((prevState) => [...assignees]);
  };

  return (
    <LeaderboardDataContext.Provider
      value={{
        reportDetails,
        updateReportDetails,
        reportAssignees,
        updateReportAssignees,
        assigneeFlaggedHrRanks,
        departmentFlaggedHrRanks,
        assigneeEfficiencyRanks,
        leaderboardTotals,
        updateLeaderboardTotals,
        departmentEfficiencyRanks,
      }}
    >
      {children}
    </LeaderboardDataContext.Provider>
  );
};
